// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/searchaggregates/v1/aggregation.proto (package chalk.searchaggregates.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { NumericValue } from "../../numericutils/v1/values_pb";
import { file_chalk_numericutils_v1_values } from "../../numericutils/v1/values_pb";
import type { Duration } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/searchaggregates/v1/aggregation.proto.
 */
export const file_chalk_searchaggregates_v1_aggregation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_numericutils_v1_values, file_google_protobuf_duration]);

/**
 * AggregationParams holds the arguments of whichever function was named, so a future parameterized
 * function (a top-K width, an exact-vs-approximate distinct count) lands here rather than as another
 * bare field beside AggregationFunction. Every field is read only for the function that defines it.
 *
 * @generated from message chalk.searchaggregates.v1.AggregationParams
 */
export type AggregationParams = Message<"chalk.searchaggregates.v1.AggregationParams"> & {
  /**
   * Percentile in (0, 100). Required iff function == PERCENTILE, ignored otherwise.
   *
   * @generated from field: optional double percentile = 1;
   */
  percentile?: number;
};

/**
 * Describes the message chalk.searchaggregates.v1.AggregationParams.
 * Use `create(AggregationParamsSchema)` to create a new message.
 */
export const AggregationParamsSchema: GenMessage<AggregationParams> = /*@__PURE__*/
  messageDesc(file_chalk_searchaggregates_v1_aggregation, 0);

/**
 * One requested aggregation. Both `field` and `params` are interpreted per `function`.
 *
 * @generated from message chalk.searchaggregates.v1.Aggregation
 */
export type Aggregation = Message<"chalk.searchaggregates.v1.Aggregation"> & {
  /**
   * @generated from field: chalk.searchaggregates.v1.AggregationFunction function = 1;
   */
  function: AggregationFunction;

  /**
   * Facet path whose column is aggregated. Required for every function except COUNT.
   *
   * @generated from field: optional string field = 2;
   */
  field?: string;

  /**
   * @generated from field: chalk.searchaggregates.v1.AggregationParams params = 3;
   */
  params?: AggregationParams;
};

/**
 * Describes the message chalk.searchaggregates.v1.Aggregation.
 * Use `create(AggregationSchema)` to create a new message.
 */
export const AggregationSchema: GenMessage<Aggregation> = /*@__PURE__*/
  messageDesc(file_chalk_searchaggregates_v1_aggregation, 1);

/**
 * Aggregation contract every surface's aggregate RPC shares, table and time-series alike, so one
 * persisted spec can drive either rendering. A time-series RPC draws one series per (group, measure),
 * so several aggregations multiply its series count; its handler caps them.
 *
 * @generated from message chalk.searchaggregates.v1.AggregateOptions
 */
export type AggregateOptions = Message<"chalk.searchaggregates.v1.AggregateOptions"> & {
  /**
   * Dimensions to group by; empty → a single scalar row.
   *
   * @generated from field: repeated string group_by = 1;
   */
  groupBy: string[];

  /**
   * "(other)" folds only when every one of these is foldable. At least one required.
   *
   * @generated from field: repeated chalk.searchaggregates.v1.Aggregation aggregations = 2;
   */
  aggregations: Aggregation[];

  /**
   * Top-N groups by the ranking aggregation; unset or <= 0 keeps all.
   *
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: chalk.searchaggregates.v1.SortOrder order = 4;
   */
  order: SortOrder;

  /**
   * @generated from field: chalk.searchaggregates.v1.OtherRowMode other_row_mode = 5;
   */
  otherRowMode: OtherRowMode;

  /**
   * @generated from field: chalk.searchaggregates.v1.NoneRowMode none_row_mode = 6;
   */
  noneRowMode: NoneRowMode;

  /**
   * Index into `aggregations` for ORDER BY and the top-N cut. Unset is 0; out of range errors.
   *
   * @generated from field: optional int32 order_by = 7;
   */
  orderBy?: number;
};

/**
 * Describes the message chalk.searchaggregates.v1.AggregateOptions.
 * Use `create(AggregateOptionsSchema)` to create a new message.
 */
export const AggregateOptionsSchema: GenMessage<AggregateOptions> = /*@__PURE__*/
  messageDesc(file_chalk_searchaggregates_v1_aggregation, 2);

/**
 * Rescales a window total to a per-interval rate. Present means "report a rate"; the knobs that
 * qualify one live here rather than beside it, so none can be set without an interval to apply to.
 *
 * @generated from message chalk.searchaggregates.v1.RateOptions
 */
export type RateOptions = Message<"chalk.searchaggregates.v1.RateOptions"> & {
  /**
   * The interval the rate is reported per (1h => a per-hour rate). Required; must be positive.
   *
   * @generated from field: google.protobuf.Duration interval = 1;
   */
  interval?: Duration;

  /**
   * Which interval to report; MIN/MAX need the ClickHouse backend, MEAN works on any.
   *
   * @generated from field: chalk.searchaggregates.v1.RateReduction reduction = 2;
   */
  reduction: RateReduction;
};

/**
 * Describes the message chalk.searchaggregates.v1.RateOptions.
 * Use `create(RateOptionsSchema)` to create a new message.
 */
export const RateOptionsSchema: GenMessage<RateOptions> = /*@__PURE__*/
  messageDesc(file_chalk_searchaggregates_v1_aggregation, 3);

/**
 * @generated from message chalk.searchaggregates.v1.AggregateRow
 */
export type AggregateRow = Message<"chalk.searchaggregates.v1.AggregateRow"> & {
  /**
   * Aligned to the request's group_by; empty in scalar mode. "(other)"/"(none)" appear as values.
   *
   * @generated from field: repeated string group = 1;
   */
  group: string[];

  /**
   * One value per requested aggregation, index-aligned.
   *
   * @generated from field: repeated chalk.numericutils.v1.NumericValue values = 2;
   */
  values: NumericValue[];
};

/**
 * Describes the message chalk.searchaggregates.v1.AggregateRow.
 * Use `create(AggregateRowSchema)` to create a new message.
 */
export const AggregateRowSchema: GenMessage<AggregateRow> = /*@__PURE__*/
  messageDesc(file_chalk_searchaggregates_v1_aggregation, 4);

/**
 * Describes a result column so the client can label and format it.
 *
 * @generated from message chalk.searchaggregates.v1.AggregateColumn
 */
export type AggregateColumn = Message<"chalk.searchaggregates.v1.AggregateColumn"> & {
  /**
   * @generated from field: chalk.searchaggregates.v1.AggregationFunction function = 1;
   */
  function: AggregationFunction;

  /**
   * @generated from field: optional string field = 2;
   */
  field?: string;

  /**
   * "count", "ms", "ns", ...
   *
   * @generated from field: string unit = 3;
   */
  unit: string;

  /**
   * Echoes the request's params, e.g. the level behind a "p98" label.
   *
   * @generated from field: chalk.searchaggregates.v1.AggregationParams params = 4;
   */
  params?: AggregationParams;

  /**
   * server-rendered header, e.g. "Count distinct(pod)"
   *
   * @generated from field: string label = 5;
   */
  label: string;
};

/**
 * Describes the message chalk.searchaggregates.v1.AggregateColumn.
 * Use `create(AggregateColumnSchema)` to create a new message.
 */
export const AggregateColumnSchema: GenMessage<AggregateColumn> = /*@__PURE__*/
  messageDesc(file_chalk_searchaggregates_v1_aggregation, 5);

/**
 * AggregateTable is one aggregate request's result: rows ordered by the primary (first)
 * aggregation, described by index-aligned columns.
 *
 * @generated from message chalk.searchaggregates.v1.AggregateTable
 */
export type AggregateTable = Message<"chalk.searchaggregates.v1.AggregateTable"> & {
  /**
   * @generated from field: repeated chalk.searchaggregates.v1.AggregateRow rows = 1;
   */
  rows: AggregateRow[];

  /**
   * @generated from field: repeated chalk.searchaggregates.v1.AggregateColumn columns = 2;
   */
  columns: AggregateColumn[];

  /**
   * True when top-N cut groups that were not folded into an "(other)" row.
   *
   * @generated from field: bool truncated = 3;
   */
  truncated: boolean;

  /**
   * Distinct groups matched, excluding "(other)" — for an honest "showing N of M".
   *
   * @generated from field: int64 total_group_count = 4;
   */
  totalGroupCount: bigint;
};

/**
 * Describes the message chalk.searchaggregates.v1.AggregateTable.
 * Use `create(AggregateTableSchema)` to create a new message.
 */
export const AggregateTableSchema: GenMessage<AggregateTable> = /*@__PURE__*/
  messageDesc(file_chalk_searchaggregates_v1_aggregation, 6);

/**
 * PERCENTILE is parameterized (level in AggregationParams.percentile), not fixed P50/P95/P99.
 *
 * @generated from enum chalk.searchaggregates.v1.AggregationFunction
 */
export enum AggregationFunction {
  /**
   * @generated from enum value: AGGREGATION_FUNCTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * count(*); no measure field
   *
   * @generated from enum value: AGGREGATION_FUNCTION_COUNT = 1;
   */
  COUNT = 1,

  /**
   * @generated from enum value: AGGREGATION_FUNCTION_COUNT_DISTINCT = 2;
   */
  COUNT_DISTINCT = 2,

  /**
   * @generated from enum value: AGGREGATION_FUNCTION_SUM = 3;
   */
  SUM = 3,

  /**
   * @generated from enum value: AGGREGATION_FUNCTION_AVG = 4;
   */
  AVG = 4,

  /**
   * @generated from enum value: AGGREGATION_FUNCTION_MIN = 5;
   */
  MIN = 5,

  /**
   * @generated from enum value: AGGREGATION_FUNCTION_MAX = 6;
   */
  MAX = 6,

  /**
   * @generated from enum value: AGGREGATION_FUNCTION_PERCENTILE = 7;
   */
  PERCENTILE = 7,
}

/**
 * Describes the enum chalk.searchaggregates.v1.AggregationFunction.
 */
export const AggregationFunctionSchema: GenEnum<AggregationFunction> = /*@__PURE__*/
  enumDesc(file_chalk_searchaggregates_v1_aggregation, 0);

/**
 * How a per-interval rate reduces to one number: MEAN divides the window, MIN/MAX read whole buckets.
 *
 * @generated from enum chalk.searchaggregates.v1.RateReduction
 */
export enum RateReduction {
  /**
   * MEAN, which is what a rate meant before this field existed
   *
   * @generated from enum value: RATE_REDUCTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RATE_REDUCTION_MEAN = 1;
   */
  MEAN = 1,

  /**
   * partial boundary buckets are excluded, so every bucket is equal-width
   *
   * @generated from enum value: RATE_REDUCTION_MIN = 2;
   */
  MIN = 2,

  /**
   * partial boundary buckets are excluded, so every bucket is equal-width
   *
   * @generated from enum value: RATE_REDUCTION_MAX = 3;
   */
  MAX = 3,
}

/**
 * Describes the enum chalk.searchaggregates.v1.RateReduction.
 */
export const RateReductionSchema: GenEnum<RateReduction> = /*@__PURE__*/
  enumDesc(file_chalk_searchaggregates_v1_aggregation, 1);

/**
 * "(other)" tail-row policy for a top-N result, independent of the (none) policy. Only a foldable
 * measure can have one — COUNT/SUM fold by summing, MIN/MAX by min/max — since no per-group
 * combination reconstructs a distinct count, an average, or a percentile.
 *
 * @generated from enum chalk.searchaggregates.v1.OtherRowMode
 */
export enum OtherRowMode {
  /**
   * per-function default: fold foldable measures, omit the rest
   *
   * @generated from enum value: OTHER_ROW_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OTHER_ROW_MODE_OMIT = 1;
   */
  OMIT = 1,

  /**
   * InvalidArgument when a requested measure is not foldable
   *
   * @generated from enum value: OTHER_ROW_MODE_FOLD = 2;
   */
  FOLD = 2,
}

/**
 * Describes the enum chalk.searchaggregates.v1.OtherRowMode.
 */
export const OtherRowModeSchema: GenEnum<OtherRowMode> = /*@__PURE__*/
  enumDesc(file_chalk_searchaggregates_v1_aggregation, 2);

/**
 * "(none)" row policy for empty/null group values, independent of the (other) policy.
 *
 * @generated from enum chalk.searchaggregates.v1.NoneRowMode
 */
export enum NoneRowMode {
  /**
   * include
   *
   * @generated from enum value: NONE_ROW_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NONE_ROW_MODE_INCLUDE = 1;
   */
  INCLUDE = 1,

  /**
   * @generated from enum value: NONE_ROW_MODE_EXCLUDE = 2;
   */
  EXCLUDE = 2,
}

/**
 * Describes the enum chalk.searchaggregates.v1.NoneRowMode.
 */
export const NoneRowModeSchema: GenEnum<NoneRowMode> = /*@__PURE__*/
  enumDesc(file_chalk_searchaggregates_v1_aggregation, 3);

/**
 * Sort direction for the ranking measure. UNSPECIFIED is DESC, the top-N default.
 *
 * @generated from enum chalk.searchaggregates.v1.SortOrder
 */
export enum SortOrder {
  /**
   * @generated from enum value: SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_ORDER_DESC = 1;
   */
  DESC = 1,

  /**
   * @generated from enum value: SORT_ORDER_ASC = 2;
   */
  ASC = 2,
}

/**
 * Describes the enum chalk.searchaggregates.v1.SortOrder.
 */
export const SortOrderSchema: GenEnum<SortOrder> = /*@__PURE__*/
  enumDesc(file_chalk_searchaggregates_v1_aggregation, 4);

